"use client";

import { useScrollDepth } from "@/lib/posthog-tracking";

export function ScrollDepthTracker() {
  useScrollDepth();
  return null;
}
